
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jira-connect",
      function () {
        return require("private-next-pages/jira-connect.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jira-connect"])
      });
    }
  